export const geUuid = () => Math.floor(
  Date.now() / 1000
);

export const slugify = (str) => str
  .toLowerCase()
  .trim()
  .replace(/[^\w\s-]/g, '')
  .replace(/[\s_-]+/g, '-')
  .replace(/^-+|-+$/g, '');

export const getEbayCategoryPath = (categoryList, leafCategoryId, path = []) => {
  const [temp] = categoryList.filter(({ categoryId }) => categoryId === leafCategoryId);
  if (temp?.categoryId && temp?.categoryParentID && temp?.categoryParentID !== temp?.categoryId) {
    return getEbayCategoryPath(categoryList, temp?.categoryParentID, [temp, ...path]);
  }
  return [temp, ...path];
};

export const prepareVehicleList = (carList) => Object.keys(carList).reduce((accumulator, currentValue) => {
  return {
    ...accumulator,
    [currentValue]: {
      model: Object.keys(carList[currentValue]),
      year: Object.keys(carList[currentValue])?.map((model) => Object.keys(carList[currentValue][model]))
    }
  };
}, {});

export const mergeObjects = (obj1, obj2) => {
  const mergedObj = { ...obj1 };
  // eslint-disable-next-line array-callback-return
  Object.entries(obj2).map(([key, value]) => {
    if (typeof value === 'object' && typeof obj1[key] === 'object') {
      mergedObj[key] = mergeObjects(obj1[key], value);
    } else {
      mergedObj[key] = value;
    }
  });

  return mergedObj;
};
export default geUuid;
